import { useEffect, useRef, useState } from 'react';
import { Input } from '@asigna/kit';
import cx from 'classnames';
import { OwnerAvatar } from 'components/OwnerAvatar';
import useNetwork from 'hooks/use-network';
import { useAtom } from 'jotai/index';
import { resolveBnsName, resolveStxsName } from 'pages/AssetsPage/components/Stx20Tab/utils';
import { shortenAddress } from 'utils/helper';

import ContactIcon from '../../../images/contact_icon.svg';
import { contactsAtom } from '../../../store/contacts';
import { IContact } from '../../../types/contacts';

interface RecepientAddressInputProps {
  placeholder: string;
  onChange: (address: string) => void;
  errorText?: string;
  value?: string;
}

// TODO_R: [RP] rename to RecepientAddressInput
// TODO_R: move into SafeDetailsPage/components/
const DropDownList = (props: RecepientAddressInputProps) => {
  const { placeholder, onChange, errorText, value } = props;
  const [contacts] = useAtom(contactsAtom);
  const [network] = useNetwork();
  const [contactsListShown, setContactsListShown] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [bnsContent, setBnsContent] = useState<string | null>('');

  const handleContactPick = (contact: IContact) => {
    setBnsContent(null);
    setInputValue(contact.contact_address);
    setContactsListShown(false);
    onChange(contact.contact_address);
  };

  const handleInputChange = (value: string) => {
    setInputValue(value);
    setBnsContent(null);
    const isBns = value.includes('.');
    if (!isBns) {
      onChange(value);
    } else {
      if (value.endsWith('.stxs')) {
        resolveStxsName(value, network).then((res) => {
          if (res) {
            setBnsContent(res);
            onChange(res);
          } else {
            onChange(value);
          }
        });
      } else {
        resolveBnsName(value).then((res) => {
          if (res) {
            setBnsContent(res);
            onChange(res);
          } else {
            onChange(value);
          }
        });
      }
    }
  };

  const wrapperRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current && dropdownRef.current) {
      const wrapperWidth = wrapperRef.current.offsetWidth;
      dropdownRef.current.style.width = `${wrapperWidth}px`;
    }
  }, []);

  const matchedContact = contacts?.find((contact) => contact.contact_address === value);

  return (
    <>
      <div
        className={cx('flex relative', Boolean(errorText) && '', contactsListShown && '')}
        ref={wrapperRef}
      >
        <Input
          className={matchedContact && contacts?.length > 0 ? 'pr-30' : 'pr-0'}
          value={inputValue || ''}
          onChange={(e) => handleInputChange(e.target.value)}
          placeholder={placeholder}
        />
        {bnsContent ? (
          <div className="text-r12 absolute right-16 top-8">{shortenAddress(bnsContent)}</div>
        ) : (
          contacts?.length > 0 && (
            <button
              className="flex absolute right-8 top-16"
              onClick={() => setContactsListShown(!contactsListShown)}
            >
              <img src={ContactIcon} alt="" />
            </button>
          )
        )}
        {contactsListShown && (
          <>
            <div
              className="fixed inset-0 z-0"
              onClick={(e) => {
                e.stopPropagation();
                setContactsListShown(false);
              }}
            />
            <div
              className="flex flex-col rounded-[6px] bg-black-3 border-[.5px] border-black-4 absolute top-48 w-full mt-4 py-8 z-50 max-h-[200px] overflow-y-auto"
              ref={dropdownRef}
            >
              {contacts?.length ? (
                contacts.map((contact) => {
                  return (
                    // TODO_R: move into separate ContactItem component
                    <button
                      key={`dd-row-${contact._id}`}
                      onClick={() => handleContactPick(contact)}
                      className="flex items-center gap-12 hover:bg-white-3 px-16 py-8"
                    >
                      <OwnerAvatar size="36px" address={contact.contact_address} />
                      <div className="flex flex-col items-start">
                        <p className="text-r14 text-white">{contact.contact_name}</p>
                        <p className="text-r12 text-regular">
                          {shortenAddress(contact.contact_address)}
                        </p>
                      </div>
                    </button>
                  );
                })
              ) : (
                <div
                  // TODO_R: use makeStyles class instead
                  style={{
                    position: 'relative',
                    height: '67px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  {/* TODO: maybe 'No contacts yet'? */}
                  <p>No matches</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {!!errorText && errorText !== '' && !contactsListShown && (
        <div className="text-r14 text-error">{errorText}</div>
      )}
      {/* {!errorText && bnsContent && !contactsListShown && <BsnText>{bnsContent}</BsnText>} */}
    </>
  );
};

export default DropDownList;
